// extracted by mini-css-extract-plugin
export default {"root":"Footer_root__GPt48","content":"Footer_content__Yr-Sz"};